import { ContentWithMaxWidth } from "common/components/ContentWithMaxWidth";
import { Markdown } from "common/components/markdown/Markdown";
import * as React from "react";

export interface MultilineText {
  content: string;
  isMarkdown: boolean;
}

interface Props extends MultilineText {
  maxWidth?: boolean;
  openLinksSeparately?: boolean;
}

export function ofMarkdown(content: string): MultilineText {
  return {
    content,
    isMarkdown: true,
  };
}

export const MultilineText: React.FC<React.PropsWithChildren<Props>> = ({
  content,
  isMarkdown,
  maxWidth,
  openLinksSeparately,
}) => {
  const value = (
    <>
      {isMarkdown ? (
        <Markdown content={content} openLinksSeparately={openLinksSeparately} />
      ) : (
        <div style={{ whiteSpace: "pre-line" }}>{content}</div>
      )}
    </>
  );

  return maxWidth ? <ContentWithMaxWidth>{value}</ContentWithMaxWidth> : value;
};
